import React, { useEffect, useState } from "react";

import {
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup
} from "@material-ui/core";
import QuiqButton from "src/shared/QuiqButton";

import { History } from "history";
import "./Organizations.scss";
// import { Redirect, useLocation } from "react-router-dom";

interface OrganizationsProps {
  isUserAuthenticated: boolean;
  history: History;
}

function Organizations(props: OrganizationsProps) {
  //   if (props.isUserAuthenticated) {
  //     return <Redirect to="/spreads" />;
  //   }
  const [selectedOrg, setSelectedOrg] = useState("");
  useEffect(() => {
    localStorage.setItem("org", selectedOrg);
  }, [selectedOrg]);

  const handleOrgChange = (event: React.ChangeEvent<{}>, value: string) => {
    if (selectedOrg === value) {
      setSelectedOrg("");
    } else {
      setSelectedOrg(value);
    }
  };

  const keepSelectedOrg = () => {
    props.history.push("/spreads");
  };

  const orgs = ["wex-dev", "cnh-dev", "mmas-dev"];
  return (
    <div className="Organizations__container">
      <FormLabel id="demo-customized-radios">Select an environment</FormLabel>
      <RadioGroup
        onChange={handleOrgChange}
        name="orgs"
        row={true}
        key="org-radio-group"
        value={selectedOrg}
      >
        <div className="org-radio-group__container">
          {orgs.map((org, index) => (
            <FormControlLabel
              value={org}
              control={
                <Radio
                  color="primary"
                  checked={org === selectedOrg}
                  // onClick={this.onRadioChange}
                />
              }
              label={org}
              className="Organizations"
              key={`org-${index}`}
            />
          ))}
        </div>
        {/* <div>{selectedOrg}</div> */}
      </RadioGroup>
      <div className="ChooseOrganization_button">
        <QuiqButton
          color="blue"
          className="ChooseOrgButton"
          isDisabled={!selectedOrg}
          // isLoading={isDeleting}
          onClick={keepSelectedOrg}
        >
          SIGN IN
        </QuiqButton>
      </div>
    </div>
  );
}

export default Organizations;



// WEBPACK FOOTER //
// ./src/organizations/Organizations.tsx